import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
	name: 'safe'
})
export class SafePipe implements PipeTransform {

	constructor(protected sanitizer: DomSanitizer) { }

	public transform(value: any, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
		
		if (value) {
			value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
		
			switch (type) {
				case 'html': 
					return this.sanitizer.bypassSecurityTrustHtml(value);
				case 'style': 
					return this.sanitizer.bypassSecurityTrustStyle(value);
				case 'script': 
					return this.sanitizer.bypassSecurityTrustScript(value);
				case 'url': 
					return this.sanitizer.bypassSecurityTrustUrl(value);
				case 'resourceUrl': 
					return this.sanitizer.bypassSecurityTrustResourceUrl(value);
				default: throw new Error(`Invalid safe type specified: ${type}`);
			}	
		}

		return '';
	}



	// public transform(value: any, type: string): string { //SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
		
	// 	var retValue: string = ''
	// 	if (value) {
	// 		value = value.replace(/(?:\r\n|\r|\n)/g, '<br>');
		
	// 		switch (type) {
	// 			case 'html': 
	// 				retValue = this.sanitizer.sanitize(SecurityContext.HTML, retValue) ?? '';  //.bypassSecurityTrustHtml(value);
	// 				break;
	// 			case 'style': 
	// 				retValue = this.sanitizer.sanitize(SecurityContext.STYLE, value) ?? '' //.bypassSecurityTrustStyle(value);
	// 				break;
	// 			case 'script': 
	// 				retValue = this.sanitizer.sanitize(SecurityContext.SCRIPT, value) ?? ''; //.bypassSecurityTrustScript(value);
	// 				break;
	// 			case 'url': 
	// 				retValue = this.sanitizer.sanitize(SecurityContext.URL, value) ?? ''; //.bypassSecurityTrustUrl(value);
	// 				break;
	// 			case 'resourceUrl': 
	// 				retValue = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, value) ?? ''; //.bypassSecurityTrustResourceUrl(value);
	// 				break;
	// 			default: throw new Error(`Invalid safe type specified: ${type}`);
	// 		}	
	// 	}
	// 	return retValue;
	// }
}